import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex justify-between items-center px-8 py-4" }
const _hoisted_3 = {
  key: 1,
  class: "flex flex-col gap-4 px-8 py-4 border border-b-4 border-b-h-primary-500 rounded-md bg-white mx-8"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("strong", null, /*#__PURE__*/_toDisplayString("Data de Início: "), -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("strong", null, /*#__PURE__*/_toDisplayString("Prazo de Entrega: "), -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("strong", null, /*#__PURE__*/_toDisplayString("Pontuação: "), -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, /*#__PURE__*/_toDisplayString("Descrição: "), -1)
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "flex flex-col gap-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("strong", null, /*#__PURE__*/_toDisplayString("Arquivo de apoio enviado:"), -1)
const _hoisted_12 = {
  key: 0,
  class: "flex flex-wrap gap-2"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "p-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Table = _resolveComponent("Table")!
  const _component_ActivityCorrection = _resolveComponent("ActivityCorrection")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Loader, {
      loader: _ctx.loading.activity
    }, null, 8, ["loader"]),
    (!_ctx.loading.activity)
      ? (_openBlock(), _createElementBlock("main", _hoisted_1, [
          _createVNode(_component_Button, {
            class: "my-4 btn-simple flex gap-4",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
            icon: "pi pi-chevron-left",
            label: _ctx.$t('labels.generic', { en: 'Activities', pt: 'Atividades' })
          }, null, 8, ["label"]),
          _createElementVNode("div", null, [
            _createElementVNode("header", _hoisted_2, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.activity.title), 1),
              _createElementVNode("span", null, [
                _createVNode(_component_Button, {
                  class: "btn-simple",
                  icon: "pi pi-trash",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.confirmDeleteModal(_ctx.activityId))),
                  label: _ctx.$t('labels.generic', { en: 'Delete', pt: 'Excluir' })
                }, null, 8, ["label"]),
                _createVNode(_component_Button, {
                  class: "btn-simple",
                  icon: "pi pi-pencil",
                  onClick: _ctx.goToEdition,
                  label: _ctx.$t('labels.generic', { en: 'Edit', pt: 'Editar' })
                }, null, 8, ["onClick", "label"])
              ])
            ]),
            (_ctx.loading.activity)
              ? (_openBlock(), _createBlock(_component_Loader, {
                  key: 0,
                  loader: _ctx.loading.activity
                }, null, 8, ["loader"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("p", null, [
                    _hoisted_5,
                    _createTextVNode(" " + _toDisplayString(_ctx.startDate), 1)
                  ]),
                  _createElementVNode("p", null, [
                    _hoisted_6,
                    _createTextVNode(" " + _toDisplayString(_ctx.deliveryDate), 1)
                  ]),
                  _createElementVNode("p", null, [
                    _hoisted_7,
                    _createTextVNode(" " + _toDisplayString(_ctx.activity.scoreRange?.toFixed(1)), 1)
                  ]),
                  _createElementVNode("p", null, [
                    _hoisted_8,
                    _createTextVNode(),
                    _createElementVNode("div", {
                      innerHTML: _ctx.activity.description,
                      class: "ql-editor"
                    }, null, 8, _hoisted_9)
                  ]),
                  _createElementVNode("p", _hoisted_10, [
                    _hoisted_11,
                    (_ctx.activity.materials && _ctx.activity.materials.length > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activity.materials, (material, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "bg-h-primary-50 py-2 border rounded-md min-w-[200px] md:min-w-[300px] flex justify-between items-center gap-2 cursor-pointer",
                              onClick: _withModifiers(($event: any) => (_ctx.downloadMaterial(material)), ["prevent"])
                            }, [
                              _createVNode(_component_Button, {
                                icon: "pi pi-file",
                                class: "btn-simple",
                                label: material.name
                              }, null, 8, ["label"]),
                              _createVNode(_component_Button, {
                                icon: "pi pi-download",
                                class: "btn-simple"
                              })
                            ], 8, _hoisted_13))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_Table, {
              slotData: _ctx.studentActivities,
              columns: _ctx.columnsData,
              actions: _ctx.actions,
              filters: _ctx.filters,
              loading: false,
              hasStatus: true,
              hasActions: true,
              params: _ctx.params,
              onOnFilter: _cache[4] || (_cache[4] = ($event: any) => (_ctx.filterFor())),
              onOnToggleFilter: _cache[5] || (_cache[5] = (e, type) => _ctx.toggleFilter(e, type)),
              onOnGoTo: _cache[6] || (_cache[6] = (e) => _ctx.goToCorrection(e)),
              onOnClearFilter: _cache[7] || (_cache[7] = ($event: any) => (_ctx.clearFilter())),
              actionsTitle: _ctx.$t('labels.generic', { pt: 'Ações', en: 'Actions' }),
              onOnPaginate: _cache[8] || (_cache[8] = ($event: any) => (_ctx.paginate($event)))
            }, {
              filters: _withCtx(() => [
                (_ctx.filterType == 'status')
                  ? (_openBlock(), _createBlock(_component_Dropdown, {
                      key: 0,
                      options: _ctx.statusOptions,
                      optionLabel: 'label',
                      optionValue: 'value',
                      modelValue: _ctx.filters.status,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.status) = $event)),
                      placeholder: "Selecione o status"
                    }, null, 8, ["options", "modelValue"]))
                  : _createCommentVNode("", true),
                (_ctx.filterType == 'name')
                  ? (_openBlock(), _createBlock(_component_InputText, {
                      key: 1,
                      modelValue: _ctx.filters.name,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.name) = $event)),
                      placeholder: "Digite o nome do aluno"
                    }, null, 8, ["modelValue"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["slotData", "columns", "actions", "filters", "params", "actionsTitle"]),
            (_openBlock(), _createBlock(_component_ActivityCorrection, {
              studentActivity: _ctx.selectedStudentActivity,
              show: _ctx.correctionVisible,
              "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.correctionVisible) = $event)),
              onStudentActivityUpdated: _ctx.updateStudentActivity,
              key: _ctx.selectedStudentActivity?.id
            }, null, 8, ["studentActivity", "show", "onStudentActivityUpdated"]))
          ]),
          _createVNode(_component_ConfirmDialog, {
            group: "activity-card",
            class: "custom-dialog",
            draggable: false,
            style: { width: '80vw', maxWidth: '700px' }
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}